import axios from "axios";

export const configApiClient = axios.create({
  baseURL: "/api/",
});
